import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprControlVisibility } from '../props/IWprControlState';
import { WprBaseViewInfo } from '../../view/WprBaseViewInfo';

/**
 * ヘッダーコントロールプロパティ情報
 */
interface IWprHeaderProps extends IWprControlProps {
}

/**
 * Headerコントロール
 */
export class WprHeader extends WprBaseControlComponent<IWprHeaderProps, HTMLElement> {
	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprHeaderProps){
		super(props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return undefined;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		const props = this.getProps();
		const {name, view, className, children, ...other} = this.props;
		const state = this.getState(['style']);
		return <header {...props} {...state} {...other}>{this.props.children}</header>;
	}
	// --------------------------------------------------------------------------
}